import PersonIcon from "@material-ui/icons/Person";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CategoryIcon from "@material-ui/icons/Category";
import NotificationsIcon from "@material-ui/icons/Notifications";
import AssistantIcon from "@material-ui/icons/Assistant";
import SendIcon from "@material-ui/icons/Send";
import { softTone } from "../../theme/agendaTheme";

// D8.7.2 — Constantes + helpers de AppointmentsConfig (extraídos del god file).

// `onboardingStep` se retiró: apuntaba a pasos del wizard /onboarding y ningún consumidor
// lo leía. La edición ya no pasa por ese wizard (ver BusinessDataDialog).
export const CONFIG_CARD_DEFS = [
  { id: "servicios",   titleKey: "cardServiciosTitle",   descKey: "cardServiciosDesc",   icon: CategoryIcon },
  { id: "equipo",      titleKey: "cardEquipoTitle",      descKey: "cardEquipoDesc",      icon: PersonIcon },
  { id: "horarios",    titleKey: "cardHorariosTitle",    descKey: "cardHorariosDesc",    icon: ScheduleIcon },
  { id: "secuencias",  titleKey: "cardSecuenciasTitle",  descKey: "cardSecuenciasDesc",  icon: NotificationsIcon },
  { id: "agente-ia",   titleKey: "cardAgenteIaTitle",    descKey: "cardAgenteIaDesc",    icon: AssistantIcon },
  { id: "mensajeria",  titleKey: "cardMensajeriaTitle",  descKey: "cardMensajeriaDesc",  icon: SendIcon },
];

// ─── Datos del negocio (compartidos por AgendaSetupWizard y BusinessDataDialog) ──
// Vivían duplicados dentro del wizard; el diálogo de edición necesita las mismas listas.
export const BUSINESS_PROFILES = [
  { id: 1, name: "Reservas de servicios",    desc: "Salones de belleza, barberías, spas, clínicas estéticas",       color: "#EC4899" },
  { id: 2, name: "Agenda comercial / ventas", desc: "Asesores, consultores, agencias, negocios B2B",                color: "#F59E0B" },
  { id: 3, name: "Consultas de salud",        desc: "Médicos, psicólogos, nutricionistas, fisioterapeutas",         color: "#10B981" },
  { id: 4, name: "Educación y formación",     desc: "Tutores, coaches, academias, formadores independientes",       color: "#3B82F6" },
  { id: 5, name: "Servicios técnicos",        desc: "Técnicos, instaladores, plomeros, electricistas, reparaciones", color: "#8B5CF6" },
];

export const TIMEZONES = [
  "America/Lima", "America/Bogota", "America/Mexico_City", "America/Santiago",
  "America/Buenos_Aires", "America/Guayaquil", "America/Caracas", "America/Asuncion",
  "America/La_Paz", "America/Montevideo", "America/Panama", "America/Puerto_Rico",
];

export const CURRENCIES = [
  { value: "PEN", label: "PEN — Soles (Perú)" },
  { value: "USD", label: "USD — Dólar" },
  { value: "COP", label: "COP — Peso Colombiano" },
  { value: "MXN", label: "MXN — Peso Mexicano" },
  { value: "CLP", label: "CLP — Peso Chileno" },
  { value: "ARS", label: "ARS — Peso Argentino" },
  { value: "BOB", label: "BOB — Boliviano" },
  { value: "GTQ", label: "GTQ — Quetzal" },
  { value: "UYU", label: "UYU — Peso Uruguayo" },
];

export const BUSINESS_DIALOG_EMPTY = {
  businessName: "", profileId: null, profileName: "", timezone: "America/Lima", currency: "PEN",
};

// ─── Constantes visuales ───────────────────────────────────────────────────
export const SVC_FALLBACK_COLORS = ["#3B82F6", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444"];

// D4 — Antes eran cuartetos bg/color/border fijos (pastel claro + texto oscuro): en dark
// se veían como manchas claras con texto ilegible. Ahora solo se declara el matiz base y
// el par fondo/texto lo deriva `softTone(hue, mode)` con contraste AA en ambos temas.
export const SEQ_CATEGORY_HUES = {
  "Recordatorio": "#3B82F6",
  "Fidelización": "#8B5CF6",
  "Necesario":    "#10B981",
  "Contenido":    "#F59E0B",
};

export const SEQ_CATEGORIES = Object.keys(SEQ_CATEGORY_HUES);

export function seqCategoryStyle(category, mode, fallback = "Recordatorio") {
  const dot = SEQ_CATEGORY_HUES[category] || SEQ_CATEGORY_HUES[fallback];
  const tone = softTone(dot, mode);
  return { dot, bg: tone.backgroundColor, color: tone.color, border: tone.borderColor };
}

// Chips informativos de las tarjetas de servicio (duración, precio, nombre)
export const SVC_CHIP_HUES = {
  name: "#F97316",
  duration: "#3B82F6",
  price: "#10B981",
};

export function svcChipStyle(kind, mode) {
  return softTone(SVC_CHIP_HUES[kind] || SVC_CHIP_HUES.name, mode);
}

export const TRIGGER_UNITS = [
  { value: "minute", label: "minuto(s)" },
  { value: "hour",   label: "hora(s)"   },
  { value: "day",    label: "día(s)"    },
];

export const TRIGGER_DIRS = [
  { value: "before", label: "antes de la cita"   },
  { value: "after",  label: "después de la cita" },
];

export const SEQ_DIALOG_EMPTY = {
  name: "", description: "", category: "Recordatorio",
  triggerValue: 1, triggerUnit: "hour", triggerDirection: "before",
  messageTemplate: "",
};

export const SEQ_VARS_HINT = "{nombre}  {fecha}  {codigo}  {servicio}  {profesional}";

export const SVC_DIALOG_EMPTY = {
  serviceName: "", description: "", durationMin: 60, price: "", requiresProfessional: true,
};

export const PROF_DIALOG_EMPTY = {
  name: "", roleLabel: "", specialty: "", whatsappUserId: "",
};

// Claves que pertenecen a la pestaña "Secuencia Agente IA" (disparadas por evento/acción)
export const AGENT_SEQ_KEYS = new Set(["confirmation", "cancellation", "reschedule"]);

export const DAY_NAMES = { 1:"Lunes", 2:"Martes", 3:"Miércoles", 4:"Jueves", 5:"Viernes", 6:"Sábado", 7:"Domingo" };
export const SLOT_OPTIONS = [15, 30, 45, 60, 90, 120];
export const DEFAULT_DAYS = [1,2,3,4,5,6,7].map(d => ({
  dayOfWeek: d, isOpen: d <= 5, openTime: "09:00", closeTime: "18:00", slotDuration: 60,
}));

export const AVATAR_COLORS = [
  "#3B82F6", "#8B5CF6", "#10B981", "#F59E0B",
  "#EF4444", "#EC4899", "#06B6D4", "#84CC16",
];

export function avatarColor(index) { return AVATAR_COLORS[index % AVATAR_COLORS.length]; }

const ROLE_CHIP_DEFS = {
  admin: { label: "Admin",    hue: "#3B82F6" },
  super: { label: "Super",    hue: "#8B5CF6" },
  user:  { label: "Operador", hue: "#10B981" },
};

export function roleChipProps(profile, mode) {
  const def = ROLE_CHIP_DEFS[profile];
  const tone = softTone(def ? def.hue : "#6B7280", mode);
  return {
    label: def ? def.label : profile || "Sin rol",
    bg: tone.backgroundColor,
    color: tone.color,
    border: tone.borderColor,
  };
}
